import {applyMiddleware, compose, createStore} from 'redux';
import {IAppState} from "src/store/models";
import {rootReducer} from './reducer';

const initialState: IAppState = {
    boxes: {},
    draggingElement: {
        id: '',
        type: ''
    },
    fruits: {},
    mappedTrees: 0,
    shelves: {},
    shelvesOrder: []
};
const enhancers = [];

if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = compose(applyMiddleware(), ...enhancers);

export default createStore(rootReducer, initialState, composedEnhancers);


// WEBPACK FOOTER //
// ./src/store/store.ts